import script from "./product.vue?vue&type=script&setup=true&lang=js"
export * from "./product.vue?vue&type=script&setup=true&lang=js"

import "./product.vue?vue&type=style&index=0&id=437ee742&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437ee742"]])

export default __exports__